import "../styles/scss/site.scss"

// Vendor imports
import "./modules/jquery-globals"
import "alpinejs"

import "lazysizes/plugins/respimg/ls.respimg"
import "lazysizes/plugins/parent-fit/ls.parent-fit"
import "lazysizes"
import "lazysizes/plugins/object-fit/ls.object-fit"

import "@fancyapps/fancybox"

import objectFitVideos from "object-fit-videos"
objectFitVideos()

// Module imports
import "./modules/svgIconSprite"
import "./modules/accordion"
import "./modules/carousel"
import "./modules/filters"
import "./modules/google-maps"
import "./modules/patches"
import "./modules/scroller"
import "./modules/toggler"
import "./modules/video-fit"
import "./modules/autoplay-videos"
import "./modules/formieEvents"

/**
 * Vite HMR — `module.hot` is Webpack-only and throws in production.
 */
if (import.meta.hot) {
	import.meta.hot.accept()
}
